<textarea [formControlName]="controlName" id="summernote"></textarea>
<field-error-display-control [displayError]="parentForm.showFieldError(controlName)" [errorMsg]="parentForm.getErrorMessageHtml(controlName)"> </field-error-display-control>
